/**
 * Legacy `challenge` ACF field `deadline` as DD/MM/YYYY (e.g. 08/05/2026).
 * A challenge is "ended" after local end of that calendar day.
 */

/** @param {unknown} value */
export function normalizeDeadlineRaw(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "object" && value !== null) {
    if (value.value != null && value.value !== "") return String(value.value).trim();
    if (value.label != null && value.label !== "") return String(value.label).trim();
  }
  return String(value).trim();
}

/**
 * @param {string} dateString DD/MM/YYYY
 * @returns {Date | null} local end of that day (23:59:59.999)
 */
export function parseDeadlineEndOfDayLocal(dateString) {
  const s = typeof dateString === "string" ? dateString.trim() : "";
  if (!s || !s.includes("/")) return null;
  const parts = s.split("/");
  if (parts.length !== 3) return null;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  if (!year || !month || !day) return null;
  const end = new Date(year, month - 1, day, 23, 59, 59, 999);
  return Number.isNaN(end.getTime()) ? null : end;
}

/**
 * @param {Record<string, unknown> | null | undefined} acf
 * @param {Date} [now]
 * @returns {boolean}
 */
export function isChallengePastDeadline(acf, now = new Date()) {
  if (!acf || typeof acf !== "object") return false;
  const raw = normalizeDeadlineRaw(acf.deadline);
  if (!raw) return false;
  if (raw.includes("-")) {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return false;
    d.setHours(23, 59, 59, 999);
    return now.getTime() > d.getTime();
  }
  const end = parseDeadlineEndOfDayLocal(raw);
  if (!end) return false;
  return now.getTime() > end.getTime();
}

/**
 * @param {Record<string, unknown> | null | undefined} post REST challenge object
 * @param {Date} [now]
 */
export function isLegacyChallengeListItemEnded(post, now = new Date()) {
  if (!post || typeof post !== "object") return false;
  if (post.status === "completed") return true;
  return isChallengePastDeadline(post.acf, now);
}

/**
 * @param {{ acf?: Record<string, unknown>; status?: string } | null | undefined} data REST single post
 * @param {Date} [now]
 */
export function isLegacyChallengeDetailBlocked(data, now = new Date()) {
  if (!data || typeof data !== "object") return false;
  if (data.status === "completed") return true;
  return isChallengePastDeadline(data.acf, now);
}
